import { Attraction } from "@/common/types"
import { Grid, IconButton, Paper, Typography } from "@mui/material"
import EditIcon from "@mui/icons-material/Edit"
import DeleteIcon from "@mui/icons-material/Delete"
import useDialogState from "@/hooks/useDialogState"
import EditAttractionDialog from "@/dialogs/attractions/EditAttractionDialog"

export default function AdminAttractionCard({
  attraction,
}: {
  attraction: Attraction
}) {
  const { openDialog: openEdit, ...editDialogState } = useDialogState({})
  // Note: Delete functionality not implemented yet, matching the instructions to skip complex operations
  const handleDelete = () => {
    console.log("Delete attraction:", attraction.attraction_id)
    // TODO: Implement delete dialog and functionality
  }

  return (
    <>
      <Paper
        sx={{
          padding: 2,
          borderRadius: "12px",
          borderColor: "stroke",
          borderStyle: "solid",
          borderWidth: "1px",
          margin: 2,
        }}
      >
        <Grid container>
          <Grid item xs={3}>
            <Typography>{attraction.title}</Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography>{attraction.location}</Typography>
          </Grid>
          <Grid item xs={4}></Grid>
          <Grid item xs={1}>
            <IconButton sx={{ padding: 0 }} onClick={openEdit}>
              <EditIcon color="primary" />
            </IconButton>
          </Grid>
          <Grid item xs={1}>
            <IconButton sx={{ padding: 0 }} onClick={handleDelete}>
              <DeleteIcon color="error" />
            </IconButton>
          </Grid>
        </Grid>
      </Paper>
      <EditAttractionDialog {...editDialogState} attraction={attraction} />
    </>
  )
}
